export default __webpack_public_path__ + "aa9537797aa1a559e2cf180930f1613d.png";